import { render, staticRenderFns } from "./m-autofill-data.vue?vue&type=template&id=5b4e5d50&scoped=true&lang=pug"
import script from "./m-autofill-data.vue?vue&type=script&lang=js"
export * from "./m-autofill-data.vue?vue&type=script&lang=js"
import style0 from "./m-autofill-data.vue?vue&type=style&index=0&id=5b4e5d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e5d50",
  null
  
)

export default component.exports